var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddImage = function SvgAddImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.25 4.667V.417h2.833v4.25h4.25V7.5h-4.25v4.25H4.25V7.5H0V4.667zm4.25 8.5v-4.25h4.25v-4.25h9.917L25.259 7.5h4.491a2.84 2.84 0 0 1 2.833 2.833v17a2.84 2.84 0 0 1-2.833 2.834H7.083a2.84 2.84 0 0 1-2.833-2.834V13.167zm9.917 12.75a7.086 7.086 0 0 0 7.083-7.084 7.086 7.086 0 0 0-7.083-7.083 7.086 7.086 0 0 0-7.084 7.083 7.086 7.086 0 0 0 7.084 7.084m-4.534-7.084a4.53 4.53 0 0 0 4.534 4.534 4.53 4.53 0 0 0 4.533-4.534 4.53 4.53 0 0 0-4.533-4.533 4.53 4.53 0 0 0-4.534 4.533"
  })));
};
export { SvgAddImage as ReactComponent };